class Common {
    modalNlOpen() {
        $('.openNl').click(function (e) {
            e.preventDefault();
            $('#footer-widget-area .overlayNl, #footer-widget-area .modale').addClass('on');
        });
    }
    modalNlClose() {
        $('.overlayNl, .modale .close').click(function(){
            $('#footer-widget-area .overlayNl, #footer-widget-area .modale').removeClass('on');
        });
    }
}

export default Common;